import React from "react";

const DataParkirOffStreet = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Dashboard Perparkiran"
        src="https://datastudio.google.com/embed/reporting/12f55cea-9d4a-483d-9cbf-19bf48c14c09/page/WPC4F"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default DataParkirOffStreet;
